module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA9ElEQVQ4jcWSrUpEURSFv3vnKggaDQpqFoMYrCaLyWQzaLOIKAgGwQeY5gP4ED6EjyAGg8kyaaaIIPNZztHjZu51wOCCDWev/bPW4ZxKpQOHwBLQb2uoi3MDHIX6CBgGbg+Y+crUHJX6oO4WXIxt9VGdzVwVrrAAfABvydF6cvkEvANzwDwwmOSgdHKqDvzGSL1Re7Ef9UzdLMi+7bgr+lbUgxoYA/vJ0AZw0fomcAzspPMVsBXtX3eoZ9yWM3VQWO5Qz1grk7hgGvT+uuAH/n9B/ImrwOIvM0PgOSdNUbgETqYUvgfO44LX5KCZNFFgDLzk5BMHmPNaSijwYQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alarm/alarm-icon.png
// module id = Mjr1
// module chunks = 1